import { optOutEnterpriseToggleLabel } from './ClientOptOutItem.locstring.json';
import { optOutToggleLabel } from 'owa-locstrings/lib/strings/optouttogglelabel.locstring.json';
import loc from 'owa-localize';
import { observer } from 'mobx-react-lite';
import { Toggle } from 'office-ui-fabric-react/lib/components/Toggle';
import clientOptOut from './actions';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

import * as React from 'react';
import WebSessionType from 'owa-service/lib/contract/WebSessionType';
import isFeatureEnabled from 'owa-feature-flags/lib/utils/isFeatureEnabled';
import store from './store';

const styles = require('./ClientOptOutItem.scss');
const classNames = require('classnames/bind').bind(styles);

type App = 'calendar' | 'people';

export function createOptOutToggleHandler(app?: App) {
    const optOutPath = app ? [`?path=/${app}`] : [];
    return function onOptOutToggle(event: any) {
        event.stopPropagation();
        event.preventDefault();

        clientOptOut(...optOutPath);
    };
}

const _OptOutComponent = (props: { app?: App; item?: any }) => {
    const label =
        getUserConfiguration().SessionSettings.WebSessionType === WebSessionType.ExoConsumer
            ? loc(optOutToggleLabel)
            : loc(optOutEnterpriseToggleLabel);

    const onOptOutToggle = React.useMemo(() => createOptOutToggleHandler(props.app), [props.app]);

    return (
        <div
            onClick={onOptOutToggle}
            className={classNames(
                styles.toggleWrapper,
                isFeatureEnabled('fwk-fluentCommandBar') && styles.fluent
            )}>
            <Toggle
                className={styles.optOutToggle}
                checked={store.isClientOptedIn}
                onText={label}
                offText={label}
                ariaLabel={label}
                onClick={onOptOutToggle}
                {...(props.item && {
                    'aria-setsize': props.item['aria-setsize'],
                    'aria-posinset': props.item['aria-posinset'],
                })}
            />
        </div>
    );
};

export const OptOutToggle = observer(_OptOutComponent);
